export default __webpack_public_path__ + "static/media/lockQuestion.69581140.svg";